import { api } from "@/api";

export async function deleteFavoriteLeague(id: number) {
  const res = await api.client.delete(`/leagues-new/favorite/${id}`);
  return res.data;
}
